/* =========================================================
   BR STUDIO — theme.js
   Mobile drawer, live cart drawer, add-to-cart, announcement
   bar, predictive search, floating buttons, FAQ helpers.
   Vanilla JS, no dependencies. Loaded once from theme.liquid,
   which also sets window.BRS (routes + a few Theme settings).
   ========================================================= */
(function () {
  'use strict';

  var CFG = window.BRS || {};
  var R = CFG.routes || {};
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function url(base, fallback) { return (base || fallback).replace(/\/$/, ''); }
  var CART_ADD = url(R.cartAdd, '/cart/add') + '.js';
  var CART_CHANGE = url(R.cartChange, '/cart/change') + '.js';
  var CART_UPDATE = url(R.cartUpdate, '/cart/update') + '.js';
  var CART_URL = R.cart || '/cart';

  /* ---------- Mobile nav drawer ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = toggle.classList.toggle('open');
      drawer.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        toggle.classList.remove('open');
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* =========================================================
     CART
     The drawer's markup comes from sections/cart-drawer.liquid.
     Every change asks Shopify to re-render that section and the
     panel is swapped in place, so prices, discounts and the
     free-delivery bar are always Shopify's own numbers.
     ========================================================= */
  function drawer() { return document.getElementById('cartDrawer'); }
  function panel() { var d = drawer(); return d && d.querySelector('[data-cart-panel]'); }

  function openCart() {
    var d = drawer();
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = d.querySelector('.cart-drawer__close');
    if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 60);
  }
  function closeCart() {
    var d = drawer();
    if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setCount(n) {
    if (n == null || isNaN(n)) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  // Swap the drawer panel with freshly rendered markup.
  function renderDrawer(html) {
    var p = panel();
    if (!p || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-panel]');
    if (!fresh) return;
    p.innerHTML = fresh.innerHTML;
    var count = p.querySelector('.cart-drawer__count');
    if (count) setCount(parseInt(count.textContent, 10));
  }

  function fetchDrawer() {
    return fetch((R.root || '/') + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) { renderDrawer(json['cart-drawer']); })
      .catch(function () {});
  }

  function busy(on) { var p = panel(); if (p) p.classList.toggle('is-busy', on); }

  function showCartError(msg) {
    var el = panel() && panel().querySelector('[data-cart-error]');
    if (el) el.textContent = msg || '';
  }

  function changeLine(line, qty) {
    busy(true);
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { showCartError(res.json.description || res.json.message); return; }
        if (res.json.sections) renderDrawer(res.json.sections['cart-drawer']);
        setCount(res.json.item_count);
        if (document.body.classList.contains('template-cart')) location.reload();
      })
      .catch(function () { location.reload(); })
      .finally(function () { busy(false); });
  }

  function initCart() {
    // Open: any [data-cart-open] (the header icon). Only when a drawer exists.
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && drawer()) { e.preventDefault(); openCart(); fetchDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }

      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var n = parseInt(line.getAttribute('data-cart-line'), 10);
      var now = parseInt(line.getAttribute('data-cart-qty-now'), 10) || 1;
      if (e.target.closest('[data-cart-remove]')) { changeLine(n, 0); return; }
      var step = e.target.closest('[data-cart-qty]');
      if (step) changeLine(n, Math.max(0, now + (step.getAttribute('data-cart-qty') === '+' ? 1 : -1)));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    // Cart note — saved quietly as the visitor types.
    var noteTimer;
    document.addEventListener('input', function (e) {
      if (!e.target.matches('[data-cart-note]')) return;
      clearTimeout(noteTimer);
      var v = e.target.value;
      noteTimer = setTimeout(function () {
        fetch(CART_UPDATE, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: v })
        }).catch(function () {});
      }, 400);
    });

    // Discount codes (snippets/cart-discount.liquid). /cart/update.js replaces the
    // whole set of codes, so the ones already accepted are sent again each time.
    function codesIn(box) {
      return Array.from(box.querySelectorAll('[data-cart-discount-remove]')).map(function (b) { return b.getAttribute('data-cart-discount-remove'); });
    }
    function postCodes(codes) {
      return fetch(CART_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function refreshCart() {
      if (document.body.classList.contains('template-cart')) { location.reload(); return Promise.resolve(); }
      return fetchDrawer();
    }
    function updateCodes(box, codes, tried) {
      var msg = box.querySelector('[data-cart-discount-msg]');
      msg.textContent = '';
      box.classList.add('is-busy');
      postCodes(codes)
        .then(function (cart) {
          var accepted = (cart.discount_codes || []).some(function (c) {
            return c.applicable && c.code.toUpperCase() === (tried || '').toUpperCase();
          });
          if (tried && !accepted) {
            // Take the refused code back off so it doesn't follow the visitor to checkout.
            return postCodes(codesIn(box)).then(function () { msg.textContent = box.getAttribute('data-msg-invalid'); });
          }
          return refreshCart();
        })
        .catch(function () { msg.textContent = box.getAttribute('data-msg-error'); })
        .finally(function () { box.classList.remove('is-busy'); });
    }
    function applyTyped(box) {
      var input = box.querySelector('[data-cart-discount-input]');
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      var codes = codesIn(box).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
      codes.push(code);
      updateCodes(box, codes, code);
    }
    document.addEventListener('click', function (e) {
      var box = e.target.closest('[data-cart-discount]');
      if (!box) return;
      if (e.target.closest('[data-cart-discount-apply]')) { applyTyped(box); return; }
      var rm = e.target.closest('[data-cart-discount-remove]');
      if (rm) {
        var gone = rm.getAttribute('data-cart-discount-remove');
        updateCodes(box, codesIn(box).filter(function (c) { return c !== gone; }));
      }
    });
    // Enter applies the code; on the cart page it would otherwise submit the cart form to checkout.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-cart-discount-input]')) return;
      e.preventDefault();
      applyTyped(e.target.closest('[data-cart-discount]'));
    });

    // Terms checkbox — the browser blocks checkout until it is ticked; tint the label while it is missing.
    document.addEventListener('invalid', function (e) {
      if (e.target.matches && e.target.matches('.cart-terms input')) e.target.closest('.cart-terms').classList.add('is-invalid');
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.cart-terms input')) e.target.closest('.cart-terms').classList.toggle('is-invalid', !e.target.checked);
    });
  }

  /* ---------- Add to cart (product forms) ----------
     FormData sends exactly what a normal submit would: only the ticked
     add-ons, the chosen package, the quantity and filled-in fields. */
  function formError(form, msg) {
    var el = form.querySelector('[data-form-error]');
    if (el) el.textContent = msg || '';
  }

  function initAddToCart() {
    document.querySelectorAll('form[action$="/cart/add"], form#productForm').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Forms with a file upload need Shopify's own multipart POST.
        if (form.querySelector('input[type=file]')) return;
        e.preventDefault();
        formError(form, '');
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

        var fd = new FormData(form);
        Array.from(fd.keys()).forEach(function (k) {
          if (/^properties\[/.test(k) && fd.getAll(k).every(function (v) { return v === ''; })) fd.delete(k);
          if (/^option-\d+$/.test(k)) fd.delete(k);
        });
        var useDrawer = CFG.cartType !== 'page' && !!drawer();
        // No sections_url: this store rejects it on /cart/add.js ("must be a relative path") even for "/".
        if (useDrawer) fd.append('sections', 'cart-drawer');

        fetch(CART_ADD, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              formError(form, res.json.description || res.json.message || (typeof res.json.errors === 'string' && res.json.errors) || (CFG.t && CFG.t.cart_add_error) || 'Could not add this to the cart.');
              return false;
            }
            if (!useDrawer) { location.href = CART_URL; return false; }
            if (res.json.sections) { renderDrawer(res.json.sections['cart-drawer']); return true; }
            return fetchDrawer().then(function () { return true; });
          })
          .then(function (added) { if (added) openCart(); })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (!btn) return;
            btn.style.opacity = '';
            // A sold-out variant keeps its disabled button (main-product.liquid owns that state).
            var sel = form.querySelector('#variantSelect');
            var opt = sel && sel.selectedOptions[0];
            btn.disabled = !!(opt && opt.dataset.available === 'false');
          });
      });
    });
  }

  /* =========================================================
     ANNOUNCEMENT BAR
     ========================================================= */
  function initAnnounce() {
    var bar = document.querySelector('[data-announce]');
    if (!bar || bar.dataset.ready) { if (!bar) root.style.setProperty('--announce-offset', '0px'); return; }
    bar.dataset.ready = '1';
    var KEY = 'brs.announce.closed';

    var msgs = Array.from(bar.querySelectorAll('.announce__msg'));
    var i = 0, timer = null;
    var every = parseInt(bar.dataset.interval, 10) || 0;
    function show(n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) {
        var on = k === i;
        m.classList.toggle('is-active', on);
        m.setAttribute('aria-hidden', String(!on));
        m.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function play() { stop(); if (every > 0 && msgs.length > 1 && !reduceMotion) timer = setInterval(function () { show(i + 1); }, every * 1000); }
    var prev = bar.querySelector('[data-announce-prev]');
    var next = bar.querySelector('[data-announce-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
    if (next) next.addEventListener('click', function () { show(i + 1); play(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', play);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', play);
    show(0); play();

    var closeBtn = bar.querySelector('[data-announce-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      try { sessionStorage.setItem(KEY, bar.dataset.sig); } catch (e) {}
      stop();
      bar.remove();
      root.style.setProperty('--announce-offset', '0px');
    });

    // Keep the fixed header glued under the bar while it is on screen.
    // Measured every frame only while the bar is visible — this theme's body
    // is its own scroll container, so window scroll events are not reliable.
    var raf = null, visible = true;
    function sync() {
      raf = null;
      if (!bar.isConnected) { root.style.setProperty('--announce-offset', '0px'); return; }
      var b = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
      root.style.setProperty('--announce-offset', b + 'px');
      if (visible) raf = requestAnimationFrame(sync);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible && !raf) raf = requestAnimationFrame(sync);
        if (!visible) root.style.setProperty('--announce-offset', '0px');
      }).observe(bar);
    }
    sync();
  }

  /* =========================================================
     PREDICTIVE SEARCH
     ========================================================= */
  function initSearch() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    var input = modal.querySelector('[data-search-input]');
    var idle = modal.querySelector('[data-search-idle]');
    var live = modal.querySelector('[data-search-live]');
    var ctrl = null, timer = null, lastQ = '', lastFocus = null;

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); input.select(); }, 40);
    }
    function close() {
      if (!modal.classList.contains('open')) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      var typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) || document.activeElement.isContentEditable;
      if (e.key === '/' && !typing && !modal.classList.contains('open')) open(e);
    });

    function run() {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (ctrl) ctrl.abort();
      if (!q) { live.innerHTML = ''; idle.hidden = false; return; }
      ctrl = 'AbortController' in window ? new AbortController() : null;
      live.innerHTML = '<p class="search-modal__loading">Searching…</p>';
      idle.hidden = true;
      var u = (R.predictive || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=5&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=show' +
        '&section_id=predictive-search';
      fetch(u, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (q !== input.value.trim()) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-ps-results]');
          live.innerHTML = res ? res.outerHTML : '';
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });

    // Arrow keys move through the results.
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = Array.from(modal.querySelectorAll('.ps-item a, .ps-all'));
      if (!links.length) return;
      e.preventDefault();
      var at = links.indexOf(document.activeElement);
      var to = e.key === 'ArrowDown' ? Math.min(links.length - 1, at + 1) : at - 1;
      if (to < 0) input.focus(); else links[to].focus();
    });
  }

  /* =========================================================
     FLOATING BUTTONS + DOCK
     --dock-h is how much of the music player is on screen, so
     anything pinned to the bottom sits just above it.
     ========================================================= */
  function measureDock() {
    var p = document.querySelector('.brs-player');
    var h = 0;
    if (p && !p.hidden && getComputedStyle(p).display !== 'none') {
      var r = p.getBoundingClientRect();
      h = Math.max(0, Math.min(r.height, window.innerHeight - r.top));
    }
    root.style.setProperty('--dock-h', Math.round(h) + 'px');
  }

  function initDock() {
    measureDock();
    var watched = null;
    function watch() {
      var p = document.querySelector('.brs-player');
      if (!p || p === watched) return;
      watched = p;
      new MutationObserver(measureDock).observe(p, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
      if ('ResizeObserver' in window) new ResizeObserver(measureDock).observe(p);
      p.addEventListener('transitionend', measureDock);
      measureDock();
    }
    new MutationObserver(watch).observe(document.body, { childList: true });
    watch();
    window.addEventListener('resize', measureDock, { passive: true });
    window.addEventListener('load', measureDock);
  }

  /* ---------- Floating buttons vs the footer ----------
     The chat + back-to-top stack is pinned to a bottom corner, which is where
     the footer's social icons land once the page reaches its end. The footer's
     bottom row keeps that corner free instead: --float-w is how far the stack
     reaches in from its edge, plus a gap, and features.css pads the row by it
     on the stack's side. Lifting the stack over the row was tried first; with
     so little room it then sat on the newsletter's Join button. */
  function measureFloat() {
    var stack = document.querySelector('[data-float]');
    var row = document.querySelector('.site-footer .footer-bot');
    var w = 0;
    if (stack && row && getComputedStyle(stack).display !== 'none') {
      // Measured against the row's own edge (padding sits inside it), so on a
      // wide screen where the stack is already clear of the container the
      // row keeps its full width.
      var s = stack.getBoundingClientRect();
      var b = row.getBoundingClientRect();
      w = stack.classList.contains('is-left') ? s.right - b.left : b.right - s.left;
      w = Math.max(0, Math.round(w + 16));
    }
    root.style.setProperty('--float-w', w + 'px');
  }

  function initFloat() {
    measureFloat();
    window.addEventListener('resize', measureFloat, { passive: true });
    // The label's width depends on the display font, which may land late.
    window.addEventListener('load', measureFloat);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureFloat);
  }

  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn || !('IntersectionObserver' in window)) return;
    var s = document.createElement('div');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:120vh;pointer-events:none;visibility:hidden;';
    document.body.prepend(s);
    new IntersectionObserver(function (entries) { btn.classList.toggle('is-visible', !entries[0].isIntersecting); }).observe(s);
    btn.addEventListener('click', function () {
      var opts = { top: 0, behavior: reduceMotion ? 'auto' : 'smooth' };
      [window, document.documentElement, document.body].forEach(function (el) { try { el.scrollTo(opts); } catch (e) {} });
      var main = document.getElementById('MainContent');
      if (main) { main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
    });
  }

  /* ---------- Dynamic tab title ---------- */
  function initTabTitle() {
    if (!CFG.tabTitle) return;
    var original = document.title;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { original = document.title; document.title = CFG.tabTitle; }
      else document.title = original;
    });
  }

  /* ---------- FAQ accordions ----------
     One delegated listener for every .faq-item on the page. It lives here
     and nowhere else: the section used to bind its own as well, and two
     handlers toggling the same item cancel out, so nothing ever opened.
     Delegation also keeps it working after the theme editor re-renders the
     section, where a script arriving with the new HTML never runs. */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-item > button');
      if (!btn) return;
      var open = btn.parentElement.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCart();
    initAddToCart();
    initAnnounce();
    initSearch();
    initDock();
    initBackToTop();
    initFloat();
    initTabTitle();
    initFaq();
  });

  // Theme editor: re-run the bits whose sections can be re-rendered in place.
  document.addEventListener('shopify:section:load', function () { initAnnounce(); measureDock(); measureFloat(); });

  window.BRStudio = { openCart: openCart, closeCart: closeCart, refreshCart: fetchDrawer };
})();
